
import React,{useState,useEffect} from 'react';

import { Link } from 'react-router-dom';
import { PageTrafficTable, RankingTable,AllPlayers, SearchTable } from "../../components/Tables";

import logo from "../../components/Images/logo.jpg"
import mallvarna from "../../components/Images/mallvarna.jpg"
export default () => {
  const [tabs,setTab]=useState(["active","",""]);

  return (
    <>
          <header className="container">
            <div className="left site__logo">
              <a href="/#/home">
                <img src={logo} className="logo" alt="rank"/>
              </a>
            </div>
            <div class="middle">
                    <h1 className="page__title">Table Tennis Center Ranking</h1>
            </div>
            <div class="right site__logo_main">
              <a href="/" target="_blank" title="ITTF">
                <img src={mallvarna} class="logo" alt="rank2"/>
              </a>
            </div>
                  
                  
          </header>

          <div id="mainContainer" className="container white"> 
          <ul className="tabs">
            <li className={""}>
              <Link to="/">Начало</Link>
            </li>
            <li className={"active"}>
                <Link to="/ranking"  >Ранкинг</Link>
            </li>
              </ul>
            <SearchTable />
          </div>

    </>
  );
};
